// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DELETED_ENTRY = "Zmazan\u00fd";
export const EXPIRED_ENTRY = "Exspirovan\u00fd";
export const HIDDEN_ENTRY = "nad limit";
export const INACTIVE_ENTRY = "Pozastaven\u00fd";
